import * as ActionTypes from '../action-types'

const reports_defaultState = {
    summary: [],
    events: [],
    mode: ''
}

export const reports = (state = reports_defaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_INCIDENT_REPORT_THRU_DRVIDS:
        case ActionTypes.GET_DRIVER_REPORTS: {

            const { reports, events = [] } = action

            // const dummy = [
            //     {
            //         "vid": "vhc#1748398014641-NICQCjKvS_ML",
            //         "drvid": "drv#2gMB6IvMEQPd",
            //         "plate": "RFID Test + Bluetooth",
            //         "reportTime": 1758990000000,
            //         "tripNumber": 12,
            //         "totalMovingDuration": 26553010,
            //         "totalIdlingDuration": 20206990,
            //         "speeding": 0,
            //         "harshEvent": 0,
            //         "attachments_alarm": 0,
            //         "total_mdvr_alarm": 7,
            //         "overallScore": 90.33142000000001,
            //         "averageSpeed": 1.0562,
            //         "plat_daily_mileage": 15.889971000000088,
            //         "plat_daily_engine_hour": 46760000,
            //         "plat_hist_top_speed": 127,
            //         "plat_hist_mileage": 171.004537,
            //         "plat_hist_engine_hour": 1035538513,
            //         "sTime": 1759310921000,
            //         "eTime": 1759313120738,
            //         "startDay": 1759248000000,
            //         "endDay": 1759334400000,
            //         "_count": 5
            //     },
            //     {
            //         "vid": "vhc#1748398014641-NICQCjKvS_ML",
            //         "drvid": "drv#2gMB6IvMEQPd",
            //         "plate": "RFID Test + Bluetooth",
            //         "reportTime": 1759048000000,
            //         "tripNumber": 6,
            //         "totalMovingDuration": 25557010,
            //         "totalIdlingDuration": 19668990,
            //         "speeding": 0,
            //         "harshEvent": 0,
            //         "attachments_alarm": 0,
            //         "total_mdvr_alarm": 7,
            //         "overallScore": 53.08543333333333,
            //         "averageSpeed": 1.0050000000000001,
            //         "plat_daily_mileage": 13.666149999999988,
            //         "plat_daily_engine_hour": 45226000,
            //         "plat_hist_top_speed": 127,
            //         "plat_hist_mileage": 171.004537,
            //         "plat_hist_engine_hour": 1035538513,
            //         "sTime": 1759326468000,
            //         "eTime": 1759461014988,
            //         "startDay": 1759334400000,
            //         "endDay": 1759420800000,
            //         "_count": 1
            //     },
            //     {
            //         "vid": "vhc#1748398014641-NICQCjKvS_ML",
            //         "drvid": "drv#2gMB6IvMEQPd",
            //         "plate": "RFID Test + Bluetooth",
            //         "reportTime": 1759148000000,
            //         "tripNumber": 1,
            //         "totalMovingDuration": 939000,
            //         "totalIdlingDuration": 91000,
            //         "speeding": 3,
            //         "harshEvent": 2,
            //         "attachments_alarm": 0,
            //         "total_mdvr_alarm": 3,
            //         "overallScore": 6.79125,
            //         "averageSpeed": 1.0745,
            //         "plat_daily_mileage": 0.8332480000000544,
            //         "plat_daily_engine_hour": 1030000,
            //         "plat_hist_top_speed": 127,
            //         "plat_hist_mileage": 172.51791,
            //         "plat_hist_engine_hour": 1037090503,
            //         "sTime": 1759464954000,
            //         "eTime": 1759465245000,
            //         "startDay": 1759420800000,
            //         "endDay": 1759507200000,
            //         "_count": 2
            //     },
            //     {
            //         "vid": "vhc#1748398014641-NICQCjKvS_ML",
            //         "drvid": "drv#2gMB6IvMEQPd",
            //         "plate": "RFID Test + Bluetooth",
            //         "reportTime": 1759248000000,
            //         "tripNumber": 12,
            //         "totalMovingDuration": 26553010,
            //         "totalIdlingDuration": 20206990,
            //         "speeding": 8,
            //         "harshEvent": 2,
            //         "attachments_alarm": 0,
            //         "total_mdvr_alarm": 7,
            //         "overallScore": 66.33142000000001,
            //         "averageSpeed": 1.0562,
            //         "plat_daily_mileage": 15.889971000000088,
            //         "plat_daily_engine_hour": 46760000,
            //         "plat_hist_top_speed": 127,
            //         "plat_hist_mileage": 171.004537,
            //         "plat_hist_engine_hour": 1035538513,
            //         "sTime": 1759310921000,
            //         "eTime": 1759313120738,
            //         "startDay": 1759248000000,
            //         "endDay": 1759334400000,
            //         "_count": 5
            //     },
            //     {
            //         "vid": "vhc#1748398014641-NICQCjKvS_ML",
            //         "drvid": "drv#2gMB6IvMEQPd",
            //         "plate": "RFID Test + Bluetooth",
            //         "reportTime": 1759334400000,
            //         "tripNumber": 6,
            //         "totalMovingDuration": 25557010,
            //         "totalIdlingDuration": 19668990,
            //         "speeding": 2,
            //         "harshEvent": 4,
            //         "attachments_alarm": 0,
            //         "total_mdvr_alarm": 7,
            //         "overallScore": 33.08543333333333,
            //         "averageSpeed": 1.0050000000000001,
            //         "plat_daily_mileage": 13.666149999999988,
            //         "plat_daily_engine_hour": 45226000,
            //         "plat_hist_top_speed": 127,
            //         "plat_hist_mileage": 171.004537,
            //         "plat_hist_engine_hour": 1035538513,
            //         "sTime": 1759326468000,
            //         "eTime": 1759461014988,
            //         "startDay": 1759334400000,
            //         "endDay": 1759420800000,
            //         "_count": 1
            //     },
            //     {
            //         "vid": "vhc#1748398014641-NICQCjKvS_ML",
            //         "drvid": "drv#2gMB6IvMEQPd",
            //         "plate": "RFID Test + Bluetooth",
            //         "reportTime": 1759420800000,
            //         "tripNumber": 1,
            //         "totalMovingDuration": 939000,
            //         "totalIdlingDuration": 91000,
            //         "speeding": 2,
            //         "harshEvent": 4,
            //         "attachments_alarm": 0,
            //         "total_mdvr_alarm": 3,
            //         "overallScore": 74.79125,
            //         "averageSpeed": 1.0745,
            //         "plat_daily_mileage": 0.8332480000000544,
            //         "plat_daily_engine_hour": 1030000,
            //         "plat_hist_top_speed": 127,
            //         "plat_hist_mileage": 172.51791,
            //         "plat_hist_engine_hour": 1037090503,
            //         "sTime": 1759464954000,
            //         "eTime": 1759465245000,
            //         "startDay": 1759420800000,
            //         "endDay": 1759507200000,
            //         "_count": 2
            //     }
            // ]
            
            newState.summary = reports
            newState.events = events

            return newState
        }
        case ActionTypes.CREATE_INCIDENT_REPORT:
        case ActionTypes.GET_DEVICE_REPORTS: {

            const reports = action.reports
            const mode = action.mode
            
            newState.summary = [
                ...newState.summary,
                ...reports
            ]
            newState.mode = mode

            return newState
        }
        case ActionTypes.UNSET_DEVICE_REPORTS: {
            
            newState.summary = []

            return newState
        }
        default: {
            return newState;
        }
    }
}